module.exports = __webpack_public_path__ + "af57825213a340de1cba1cc1057c3077.svg";